var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarChattingOff = function SvgNavbarChattingOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M20.25 18.496V22.5H12C6.21 22.5 1.5 17.79 1.5 12S6.21 1.5 12 1.5 22.5 6.21 22.5 12a10.5 10.5 0 0 1-2.25 6.496M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9h6.75v-3.04l.173-.21A9 9 0 0 0 21 12c0-4.963-4.037-9-9-9m-5.25 9a1.124 1.124 0 1 1 2.249-.001A1.124 1.124 0 0 1 6.75 12m4.125 0a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0m5.25-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarChattingOff;